export default {
  name: "Delivery",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M23.9 17.04 23.43 13h1.92c.99 0 1.79-.65 1.99-1.65l.5-3.2c.04-.29-.04-.58-.23-.8-.19-.22-.47-.35-.76-.35h-4.11l-.24-2.12c-.06-.5-.49-.88-1-.88H18c-.55 0-1 .45-1 1s.45 1 1 1h2.61l1.28 11.09c-2.87.39-4.42 1.99-5.16 2.91H15v-4c0-1.16-.84-2-2-2H7c-.55 0-1 .45-1 1s.45 1 1 1h1v1.06c-4.77.54-7 4.92-7 7.94 0 .55.45 1 1 1h3.14c.45 1.72 2 3 3.86 3s3.41-1.28 3.86-3h6.28c.45 1.72 2 3 3.86 3s3.41-1.28 3.86-3H30c.55 0 1-.45 1-1 0-2.74-2.38-7.52-7.1-7.96zM25.67 9l-.32 2H23.2l-.23-2h2.7zM9 27c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm14 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.86-3c-.45-1.72-2-3-3.86-3s-3.41 1.28-3.86 3h-6.28c-.45-1.72-2-3-3.86-3s-3.41 1.28-3.86 3H3.1c.44-2.3 2.34-5 5.9-5 .55 0 1-.45 1-1v-2h3v5c0 .55.45 1 1 1h3.23a1 1 0 0 0 .81-.41c.52-.71 1.9-2.59 5.17-2.59 3.26 0 5.19 2.86 5.68 5h-2.03z",
  },
}
